// Shared A/B start/end marker icon paths.
//
// These icons live in the CRA public/ folder. Bare string literals are not
// rewritten by webpack, so prefix with PUBLIC_URL (set via package.json
// "homepage") to resolve under /_resources/themes/default/build on deploy.
export const startMarkerIcon = `${process.env.PUBLIC_URL}/images/marker-a.png`
export const endMarkerIcon = `${process.env.PUBLIC_URL}/images/marker-b.png`
